/*eslint-disable*/
import { usePatch, useGet, usePost } from "./useRequest";
export function patchApplication(id, values) {
  const path = `/applications/${id}`;
  return usePatch(path, values);
}

export function loadCandidateProfile(jobid, prefillId) {
  const path = `/applications/${jobid}/profile?prefillId=${prefillId}`;
  return useGet(path);
}

export function getApplicationByJob(jobid) {
  const path = `/applications/${jobid}/job`;
  return useGet(path);
}

export function addApplication(updateProfile, application, token) {
  const path = `/applications/${updateProfile}?token=${token}`;
  return usePost(path, application);
}

export function saveConfidentialQuestionnaireAnswers(jobId, data) {
  const path = `applications/${jobId}/job/confidentialquestionnaire`;
  return usePost(path, data);
}
